// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"377":"b756a812","382":"26fa42bb"}[chunkId] + ".css";
};